import { Button, Flex, Text } from '@chakra-ui/react';

import getPointsValue from 'app/utils/points';
import {
  AddCircleOutline,
  formatCurrency,
  formatNumber,
  HistoryOutline,
  InfoCircleOutline,
} from '@aslanpay/portal-common-lib';

import { CompanyWalletProps } from './CompanyWallet.types';

function BalanceCard({
  title,
  balance = 0,
  isPending = false,
}: {
  title: string;
  balance?: number;
  isPending?: boolean;
}) {
  const value = getPointsValue(balance);

  const styles = {
    pending: {
      container: {
        bgColor: 'brand.lightGray2',
      },
      title: {
        color: 'brand.mutedPurple',
      },
      balance: {
        color: 'brand.darkGray',
      },
      value: {
        color: 'brand.darkGray',
      },
    },
    default: {
      container: {
        bgColor: 'brand.lightPurple',
      },
      title: {
        color: 'brand.mutedPurple',
      },
      balance: {
        color: 'brand.darkPurple',
      },
      value: {
        color: 'brand.darkGray',
      },
    },
  };

  const style = isPending ? styles.pending : styles.default;

  return (
    <Flex
      w="280px"
      direction="column"
      gap="9px"
      p="15px 20px"
      align="flex-start"
      borderRadius="8px"
      {...style.container}
    >
      <Flex direction="row" gap="5px" align="center">
        {isPending && <InfoCircleOutline boxSize="20px" color="brand.mediumGray2" />}

        <Text as="h5" textStyle="medium" {...style.title}>
          {title}
        </Text>
      </Flex>

      <Text as="h3" textStyle="h3" {...style.balance}>
        {formatNumber(balance)}
      </Text>

      <Text as="h5" textStyle="smallMedium" {...style.value}>
        worth {formatCurrency(value)}
      </Text>
    </Flex>
  );
}

function CompanyWallet({ companyPot }: CompanyWalletProps) {
  return (
    <Flex
      direction="column"
      gap="28px"
      border="1px solid"
      borderColor="brand.lightGray1"
      p="20px"
      flex="1"
    >
      <Flex justify="space-between" gap="30px" alignItems="center" flex="1">
        <Text as="h2" textStyle="h2" color="brand.darkPurple">
          Company Wallet
        </Text>

        <Flex direction="row" gap="15px" align="center">
          <Button
            variant="outline"
            size="sm"
            isDisabled
            leftIcon={<HistoryOutline boxSize="20px" />}
            onClick={() => {
              /* TODO */
            }}
          >
            See history
          </Button>
          <Button
            size="sm"
            isDisabled
            leftIcon={<AddCircleOutline boxSize="20px" />}
            onClick={() => {
              /* TODO */
            }}
          >
            Buy points
          </Button>
        </Flex>
      </Flex>

      <Flex direction="row" gap="20px" align="center">
        <BalanceCard title="Points balance" balance={companyPot?.balance} />
        <BalanceCard title="Pending points" balance={companyPot?.pendingBalance} isPending />
      </Flex>
    </Flex>
  );
}

export default CompanyWallet;
